import { inject, Injector, PLATFORM_ID } from '@angular/core';
import { type CanActivateChildFn, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { filter, firstValueFrom } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { NavigationStore } from '@features/navigation/store/navigation.store';

// Las rutas de BD son la página base (p.ej. "app/catalogos/transportistas"); las
// sub-rutas hijas (.../:id, .../:id/editar, etc.) se permiten por prefijo de segmento.
function isPathAllowed(path: string, allowedRoutes: string[]): boolean {
    const normalized = path.replace(/^\/+/, '').replace(/\/+$/, '');
    return allowedRoutes.some((route) => normalized === route || normalized.startsWith(`${route}/`));
}

// Uso: canActivateChild en la ruta 'app'. Es la capa de UX (evita el parpadeo);
// Express y @PreAuthorize en atc-api son quienes realmente bloquean el acceso.
export const pageGuard: CanActivateChildFn = async (_childRoute, state) => {
    const navigation = inject(NavigationStore);
    const router = inject(Router);
    const injector = inject(Injector);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) return true;

    await firstValueFrom(toObservable(navigation.isLoading, { injector }).pipe(filter((loading) => !loading)));

    const allowedRoutes = navigation.menu().flatMap((modulo) => modulo.paginas.map((pagina) => pagina.route));
    const path = state.url.split('?')[0] ?? '';

    if (isPathAllowed(path, allowedRoutes)) return true;

    return router.createUrlTree(['/acceso-denegado']);
};
